import React, { useEffect, useState } from "react";
import { collection, query, where, onSnapshot, doc, updateDoc, deleteDoc, orderBy } from "firebase/firestore";
import { Table, Button, Space, Modal, message, Tag, Input } from "antd";
import dayjs from "dayjs";
import { db } from "@/firebaseConfig.js";

const { TextArea } = Input;

const AdminProcessedTransactionsTable = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [currentTransactionId, setCurrentTransactionId] = useState(null);
    const [adminMessage, setAdminMessage] = useState("");

    useEffect(() => {
        
        const q = query(collection(db, "transactions"), where("status", "!=", "pending"), orderBy('createdAt', 'descya'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
                createdAt: doc.data().createdAt?.toDate(),
            }));
            setTransactions(data);
        });

        return () => unsubscribe();
    }, []);

    const openModal = (record) => {
        setCurrentTransactionId(record.id);
        setAdminMessage(record.review || "");
        setModalVisible(true);
    };

    const handleOk = async () => {
        if (!currentTransactionId) return;
        setLoading(true);
        try {
            const transactionRef = doc(db, "transactions", currentTransactionId);
            await updateDoc(transactionRef, { review: adminMessage || null });
            message.success("Admin message updated");
            setModalVisible(false);
        } catch (err) {
            message.error("Error: " + err.message);
        } finally {
            setLoading(false);
            setCurrentTransactionId(null);
            setAdminMessage("");
        }
    };

    const handleCancel = () => {
        setModalVisible(false);
        setAdminMessage("");
    };

    const handleDelete = async (id) => {
        try {
            await deleteDoc(doc(db, "transactions", id));
            message.success("Transaction deleted successfully");
        } catch (error) {
            message.error("Error deleting transaction: " + error.message);
        }
    };

    const columns = [
        {
            title: "User ID",
            dataIndex: "userEmail",
            key: "userEmail",
            render: (text) => <Tag color="blue">{text}</Tag>,
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (amount) => `$${amount.toFixed(2)}`,
        },
        {
            title: "Method",
            dataIndex: "method",
            key: "method",
            render: (method) => <Tag color="purple">{method}</Tag>,
        },
        {
            title: "Admin Message",
            dataIndex: "review",
            key: "review",

            render: (review) => review ?
                <Tag
                    style={{width: '150px',
                whiteSpace: 'normal',
                }} color="orange">{review}</Tag> : "—",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => <Tag color={status === "approved" ? "green" : "red"}>{status}</Tag>,
        },
        {
            title: "Processed At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (date) => (date ? dayjs(date).format("YYYY-MM-DD HH:mm") : "—"),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <Button onClick={() => openModal(record)}>Edit Message</Button>
            ),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <Button danger onClick={() => handleDelete(record.id)}>Delete</Button>
            ),
        },
    ];

    return (
       <>
            <h2>Processed Transactions</h2>
                <Table
                    rowKey="id"
                    loading={loading}
                    dataSource={transactions}
                    columns={columns}
                    pagination={{ pageSize: 10 }}
                    locale={{ emptyText: "No processed transactions" }}
                />

                <Modal
                    title="Edit Admin Message"
                    open={modalVisible}
                    onOk={handleOk}
                    confirmLoading={loading}
                    onCancel={handleCancel}
                    okText="Save"
                >

                    <TextArea
                        rows={4}
                        value={adminMessage}
                        onChange={(e) => setAdminMessage(e.target.value)}
                        placeholder="Enter admin message"
                    />
                </Modal>
       </>
    );
};

export default AdminProcessedTransactionsTable;
